import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate } from '../api/dataverseClient';

export interface SprintRetrospective {
  dagrun_pm_sprintretrospectiveid: string;
  dagrun_pm_name: string;
  dagrun_pm_wentwell: string | null;
  dagrun_pm_didntgowell: string | null;
  dagrun_pm_actionitems: string | null;
  dagrun_pm_facilitatedby: string | null;
  dagrun_pm_retrodate: string | null;
  _dagrun_pm_sprintid_value: string;
  _dagrun_pm_projectid_value: string;
}

const FIELDS = [
  'dagrun_pm_sprintretrospectiveid','dagrun_pm_name','dagrun_pm_wentwell','dagrun_pm_didntgowell',
  'dagrun_pm_actionitems','dagrun_pm_facilitatedby','dagrun_pm_retrodate',
  '_dagrun_pm_sprintid_value','_dagrun_pm_projectid_value',
];

export async function getSprintRetrospective(pca: IPublicClientApplication, sprintId: string): Promise<SprintRetrospective | null> {
  const rows = await dvList<SprintRetrospective>(pca, 'dagrun_pm_sprintretrospectives', {
    select: FIELDS,
    filter: `_dagrun_pm_sprintid_value eq ${sprintId}`,
    top: 1,
  });
  return rows[0] ?? null;
}

export async function createSprintRetrospective(
  pca: IPublicClientApplication,
  fields: { sprintId: string; projectId: string; sprintName: string; facilitatedBy: string; wentWell: string; didntGoWell: string; actionItems?: string | null },
): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_sprintretrospectives', {
    dagrun_pm_name: `${fields.sprintName} — Retrospective`,
    dagrun_pm_wentwell: fields.wentWell,
    dagrun_pm_didntgowell: fields.didntGoWell,
    dagrun_pm_actionitems: fields.actionItems || null,
    dagrun_pm_facilitatedby: fields.facilitatedBy,
    dagrun_pm_retrodate: new Date().toISOString(),
    'dagrun_pm_sprintid@odata.bind': `/dagrun_pm_sprints(${fields.sprintId})`,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${fields.projectId})`,
  });
}

export async function updateSprintRetrospective(
  pca: IPublicClientApplication,
  id: string,
  fields: { wentWell?: string; didntGoWell?: string; actionItems?: string | null },
): Promise<void> {
  const patch: Record<string, unknown> = {};
  if (fields.wentWell != null)    patch.dagrun_pm_wentwell = fields.wentWell;
  if (fields.didntGoWell != null) patch.dagrun_pm_didntgowell = fields.didntGoWell;
  if (fields.actionItems !== undefined) patch.dagrun_pm_actionitems = fields.actionItems;
  return dvUpdate(pca, 'dagrun_pm_sprintretrospectives', id, patch);
}
